export interface CaptureGuide {
  id: string;
  title: string;
  badge: string;
  description: string;
  imageSrc: string;
}

const buildGuideImage = (pose: 'front' | 'left' | 'right', hairColor: string): string => {
  const faceX = pose === 'left' ? 142 : pose === 'right' ? 118 : 130;
  const noseX = pose === 'left' ? 152 : pose === 'right' ? 108 : 130;
  const shoulderPath =
    pose === 'front'
      ? 'M72 214 C95 188 165 188 188 214 L205 244 H55 Z'
      : pose === 'left'
        ? 'M62 216 C92 190 152 188 184 214 L202 244 H52 Z'
        : 'M76 214 C108 188 168 190 198 216 L208 244 H58 Z';
  const hairPath =
    pose === 'front'
      ? 'M72 104 C76 45 183 45 188 104 C190 143 171 166 130 169 C89 166 70 143 72 104 Z'
      : pose === 'left'
        ? 'M82 110 C86 48 177 44 190 112 C195 154 164 171 122 166 C91 161 75 139 82 110 Z'
        : 'M68 112 C81 44 172 48 178 110 C185 139 169 161 138 166 C96 171 65 154 68 112 Z';
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="260" height="280" viewBox="0 0 260 280" role="img">
      <rect width="260" height="280" rx="18" fill="#f5f7f6"/>
      <rect x="36" y="26" width="188" height="228" rx="22" fill="#ffffff" stroke="#d7dfda" stroke-width="2"/>
      <path d="${shoulderPath}" fill="#dfe9e5"/>
      <path d="${hairPath}" fill="${hairColor}"/>
      <ellipse cx="${faceX}" cy="118" rx="${pose === 'front' ? 45 : 38}" ry="54" fill="#d6a98f"/>
      <path d="M${noseX} 118 L${pose === 'left' ? 164 : pose === 'right' ? 96 : 137} 134 L${noseX} 136" fill="none" stroke="#a97b62" stroke-width="4" stroke-linecap="round"/>
      <circle cx="${pose === 'right' ? 118 : 142}" cy="112" r="4" fill="#27312e"/>
      ${pose === 'front' ? '<circle cx="118" cy="112" r="4" fill="#27312e"/>' : ''}
      <path d="M110 148 C122 156 138 156 150 148" fill="none" stroke="#9b6c58" stroke-width="4" stroke-linecap="round"/>
      <path d="M64 62 H42 V40 H84" fill="none" stroke="#587068" stroke-width="4" stroke-linecap="round"/>
      <path d="M196 40 H218 V62" fill="none" stroke="#587068" stroke-width="4" stroke-linecap="round"/>
      <path d="M42 218 V240 H64" fill="none" stroke="#587068" stroke-width="4" stroke-linecap="round"/>
      <path d="M218 218 V240 H196" fill="none" stroke="#587068" stroke-width="4" stroke-linecap="round"/>
    </svg>
  `;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const captureGuides: CaptureGuide[] = [
  {
    id: 'front',
    title: 'Front hair photo',
    badge: 'Required',
    description: 'Use a front-facing face photo with the full hair outline visible.',
    imageSrc: buildGuideImage('front', '#26312f'),
  },
  {
    id: 'left',
    title: 'Left side hair photo',
    badge: 'Recommended',
    description: 'Add the left side when hair length, density, or volume needs more context.',
    imageSrc: buildGuideImage('left', '#313634'),
  },
  {
    id: 'right',
    title: 'Right side hair photo',
    badge: 'Recommended',
    description: 'Add the right side to compare volume and shape across both sides.',
    imageSrc: buildGuideImage('right', '#313634'),
  },
];
